import { motion } from "framer-motion";
import {
  Monitor,
  Paintbrush,
  Smartphone,
  Code,
  Layers,
  Database
} from "lucide-react";
import { useInView } from "react-intersection-observer";
import { ServiceCard } from "./ServiceCard";
import { AnimatedBackground } from "./AnimatedBackground";
const services = [
  {
    icon: Monitor,
    title: "Frontend Development",
    description:
      "Expert implementation of modern frontend technologies including HTML5, CSS3, and JavaScript frameworks.",
  },
  {
    icon: Paintbrush,
    title: "UI/UX Redesign",
    description:
      "Transform your website with a modern, user-friendly design that looks great and helps convert more visitors into customers.",
  },
  {
    icon: Smartphone,
    title: "Responsive Design",
    description:
      "Ensure your website looks great and functions perfectly on all devices with a mobile-first approach.",
  },
  {
    icon: Database,
    title: "Backend Development",
    description:
      "Scalable backend solutions using modern frameworks for seamless API integration and efficient data management.",
  },
  {
    icon: Code,
    title: "Website Optimization",
    description:
      "Performance optimization and best practices to enhance speed, SEO, accessibility, and overall user experience.",
  },
  {
    icon: Layers,
    title: "Tech Stack Integration",
    description:
      "Quick adaptation to your tech stack for seamless integration with your existing team, workflows, and development processes.",
  },
];
export const ServicesSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  return (
    <section className="relative py-20 px-4 overflow-hidden" id="services">
      <AnimatedBackground />
   
      <div className="max-w-6xl mx-auto relative z-10">
        <motion.div
          ref={ref}
          initial={{
            opacity: 0,
          }}
          animate={
            inView
              ? {
                  opacity: 1,
                }
              : {
                  opacity: 0,
                }
          }
          transition={{
            duration: 0.8,
          }}
        >
          <div className="text-center mb-16">
            <motion.div
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={
                inView
                  ? {
                      opacity: 1,
                      y: 0,
                    }
                  : {
                      opacity: 0,
                      y: 20,
                    }
              }
              transition={{
                duration: 0.8,
                delay: 0.2,
              }}
            >
              <span className="text-blue-500 font-semibold">What I Do</span>
              <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.8 }}
          className="text-4xl sm:text-5xl font-bold mb-16 text-center"
        >
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 relative">
            Services
            <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur-sm" />
          </span>
        </motion.h2>
              <p className="text-gray-300 max-w-2xl mx-auto">
                Specialized in frontend development with a focus on creating
                beautiful, responsive user interfaces
              </p>
            </motion.div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{
                  opacity: 0,
                  y: 20,
                }}
                animate={
                  inView
                    ? {
                        opacity: 1,
                        y: 0,
                      }
                    : {
                        opacity: 0,
                        y: 20,
                      }
                }
                transition={{
                  duration: 0.5,
                  delay: index * 0.1,
                }}
              >
                <ServiceCard {...service} />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
